var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.756,
    height: 25.666,
    viewBox: "0 0 23.756 25.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25795",
    "data-name": "Group 25795",
    transform: "translate(-1.6 -0.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37361",
    "data-name": "Path 37361",
    d: "M13.3,26.137,8.343,23.283c-.547-.314-1.018-.607-1.439-.892a15.451,15.451,0,0,1-2.423-2.226,14.6,14.6,0,0,1-1.8-2.83,14.175,14.175,0,0,1-.96-3.212A25.13,25.13,0,0,1,1.6,10.9l0-5.634.523-.121a36.521,36.521,0,0,0,9.178-3.4c.543-.294,1.1-.627,1.758-1.048l.36-.231L13.787.7a32.839,32.839,0,0,0,4.177,2.21,37.2,37.2,0,0,0,6.013,2.068c.259.064.518.12.778.175l.532.115.069.56v5.948a18.471,18.471,0,0,1-.1,2.122,13.947,13.947,0,0,1-.962,3.295,14.678,14.678,0,0,1-1.812,2.86,15.535,15.535,0,0,1-2.4,2.213c-.805.55-1.641,1.012-2.45,1.458ZM2.955,6.338l0,4.572a24.227,24.227,0,0,0,.106,3.017,12.735,12.735,0,0,0,.852,2.847,13.2,13.2,0,0,0,1.6,2.522,14.078,14.078,0,0,0,2.171,1.994q.555.375,1.331.823l4.294,2.471,3.666-2.046c.78-.43,1.588-.877,2.318-1.375a14.131,14.131,0,0,0,2.154-1.983,13.3,13.3,0,0,0,1.616-2.55,12.574,12.574,0,0,0,.853-2.919,17.438,17.438,0,0,0,.089-1.937v-5.4c-.121-.027-.238-.054-.353-.083a38.653,38.653,0,0,1-6.233-2.143,33.934,33.934,0,0,1-3.986-2.078c-.536.336-1.014.616-1.484.87A37.5,37.5,0,0,1,2.955,6.338Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25794",
    "data-name": "Group 25794",
    transform: "translate(6.552 8.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37362",
    "data-name": "Path 37362",
    d: "M19.876,10.084a1.622,1.622,0,0,0-1.153-.476,1.692,1.692,0,0,0-1.152.479l-2.027,2.027L12.728,14.93l-1.686-1.686-.4-.4a1.678,1.678,0,0,0-1.152-.478,1.649,1.649,0,0,0-1.152.478,1.61,1.61,0,0,0-.481,1.15,1.706,1.706,0,0,0,.476,1.152l2.839,2.839.4.4a1.656,1.656,0,0,0,2.307,0l2.027-2.027,3.228-3.229.742-.742a1.678,1.678,0,0,0,.478-1.152A1.648,1.648,0,0,0,19.876,10.084Z",
    transform: "translate(-7.178 -8.93)",
    fill: "#f63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37363",
    "data-name": "Path 37363",
    d: "M12.649,19.45a2.3,2.3,0,0,1-1.63-.662L7.777,15.545a2.373,2.373,0,0,1-.672-1.6A2.267,2.267,0,0,1,7.768,12.3a2.322,2.322,0,0,1,1.645-.69,2.349,2.349,0,0,1,1.629.676L12.653,13.9l4.366-4.366a2.358,2.358,0,0,1,1.6-.675,2.216,2.216,0,0,1,1.637.652,2.316,2.316,0,0,1,.7,1.65,2.355,2.355,0,0,1-.676,1.63l-6,6A2.3,2.3,0,0,1,12.649,19.45ZM9.413,12.963a.989.989,0,0,0-.655.258.965.965,0,0,0-.305.665,1.033,1.033,0,0,0,.281.706l3.242,3.242a.982.982,0,0,0,1.351,0l6-6a1,1,0,0,0,.281-.675.986.986,0,0,0-.257-.653l0,0a.987.987,0,0,0-.661-.3,1.03,1.03,0,0,0-.709.282l-5.32,5.32-2.567-2.567A1,1,0,0,0,9.413,12.963Z",
    transform: "translate(-7.103 -8.855)",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.f6503d28f062eed0b4e1dd02fd3ddb1f.svg";
export { ForwardRef as ReactComponent };